import styled from 'styled-components';
import { CollocationCenterModel } from 'types/types';

import CollocationCenterItem from './CollocationCenterItem';

type TProps = {
  collocationCenters: CollocationCenterModel[];
  handleEditCollocationCenter: (x: CollocationCenterModel) => void;
};

const CollocationCentersList = ({ collocationCenters, handleEditCollocationCenter }: TProps) => {
  return (
    <Container>
      {collocationCenters.map((x) => (
        <CollocationCenterItem
          key={x.id}
          collocationCenter={x}
          handleEditCollocationCenter={() => handleEditCollocationCenter(x)}
        />
      ))}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  border-radius: 4px;
  text-align: center;
  padding-top: 0rem;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: top;

  > div {
    flex: 1;
  }
`;

export default CollocationCentersList;
